<template>
  <div
    v-if="student && student.id"
    class="d-flex flex-row flex-nowrap align-center py-2"
    @click="$emit('change', student)"
  >
    <div v-if="!$vuetify.breakpoint.mobile" class="image-wrapper mr-2">
      <img :src="avatar" alt="" />
    </div>
    <div>
      <router-link style="text-decoration: none" v-if="isLink && !isError && student.id" :to="'/student/' + student.id">
        <div style="white-space: nowrap">
          {{ student.name }}
        </div>
      </router-link>

      <div class="black--text" style="white-space: nowrap" v-else>{{ student.name }}</div>
      <div v-if="isShowCode" style="white-space: nowrap; color: #797979">
        <span v-if="!isPreview">{{ student && student.code | getStudentCode }}</span>
        <span v-else>{{ student.code }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import get from 'lodash-es/get'

export default {
  props: {
    student: Object,
    prepend: Object,
    append: Object,
    attendance: Object,
    link: Boolean,
    isShowCode: {
      type: Boolean,
      default: true,
    },
    isPreview: {
      type: Boolean,
      default: false,
    },
    isError: Boolean,
  },
  computed: {
    avatar() {
      if (this.student && this.student.avatar && this.student.avatar.url) return this.student.avatar.url
      const gender = get(this.student, 'gender', '')
      if (typeof gender === 'string' && gender.length) return require(`@/assets/${gender}.jpg`)
      return require('@/assets/default-avatar.svg')
    },
    isLink() {
      return this.link && this.$auth.policies['view-student-group']
    },
  },
  async created() {},
  methods: {},
}
</script>

<style lang="scss" scoped>
.image-wrapper {
  width: 55px;
  min-width: 55px;
  height: 55px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  justify-content: center;
  img {
    max-width: 100%;
    max-height: 100%;
    border-radius: 4px;
  }
}
</style>
